import { Route, Routes } from "react-router-dom";
import AllTimelines from "../pages/dashboardPage/timeline/allTimelines/AllTimelines";

const TimelineNavigator = () => {
  return (
    <Routes>
      <Route path="/show-all-timelines" element={<AllTimelines />} />
      <Route path="*" element={<AllTimelines />} />
    </Routes>
  );
};

export default TimelineNavigator;
